/**
 * @copyright Elmelo Ltd.
 */

import { Core } from "../../api";

/**
 *  Signs out and starts the next user from a clean slate: removes the persisted cart and
 *  reloads the page, which clears all in-memory state (chat user / channel, beta id, checkout).
 */
export const SignOut = async () => {
	try {
		const aws_core = new Core({});

		await aws_core.signOut();
	} catch (err) {
		console.warn("SignOut: err: ", err);
	}

	try {
		localStorage.removeItem("persist:root");
	} catch (err) {
		console.warn("SignOut: storage: err: ", err);
	}

	window.location.assign("/signin");
}; // SignOut
